module.exports = __webpack_public_path__ + "media/images/emblems/Troistorrents-6f60cd98575ac2f7be728d3f35d2e087.png";